<script setup lang="ts">
import { computed } from "vue";
import type { ICellRendererParams } from "ag-grid-enterprise";
import type { Charter } from "@/api/client/models/index.ts";

type ActionParams = ICellRendererParams<Charter> & {
  onUpdate: (charterId: number) => void;
  onDownload: (charterId: number) => void;
};

const props = defineProps<{
  params: ActionParams;
}>();

const charterId = computed(() => {
  const id = props.params.data?.id;
  return typeof id === "number" && Number.isSafeInteger(id) && id > 0 ? id : null;
});

function withCharterId(action: (id: number) => void): void {
  if (charterId.value !== null) {
    action(charterId.value);
  }
}

function update(): void {
  withCharterId(props.params.onUpdate);
}

function download(): void {
  withCharterId(props.params.onDownload);
}
</script>

<template>
  <span class="flex h-full items-center gap-3">
    <button
      type="button"
      class="ag-grid-button material-icons text-red"
      :class="charterId === null ? 'disabled-grid-button' : 'cursor-pointer'"
      v-tooltip.top="'Update crew briefing'"
      :disabled="charterId === null"
      aria-label="Update crew briefing"
      title="Update crew briefing"
      @click.stop="update"
    >
      update
    </button>

    <button
      type="button"
      class="ag-grid-button material-icons text-red"
      :class="charterId === null ? 'disabled-grid-button' : 'cursor-pointer'"
      v-tooltip.top="'Download crew briefing'"
      :disabled="charterId === null"
      aria-label="Download crew briefing"
      title="Download crew briefing"
      @click.stop="download"
    >
      download
    </button>
  </span>
</template>
